// "★★★★★ 5.0 from 290+ Google reviews" — shared by the instant estimate and swinging door pages.
export function GoogleRatingLine({ testid = "google-rating-line", className = "" }) {
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid={testid}>
      <div className="flex" aria-label="5 out of 5 stars">
        {[0, 1, 2, 3, 4].map((i) => (
          <svg key={i} className="w-4 h-4" viewBox="0 0 20 20" fill="#f5a623" aria-hidden="true">
            <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.2 1 5.9L10 15l-5.2 2.8 1-5.9L1.5 7.7l5.9-.9L10 1.5z" />
          </svg>
        ))}
      </div>
      <span className="text-sm font-bold text-zinc-800">5.0</span>
      <span className="text-xs text-zinc-500">from 290+ Google reviews</span>
    </div>
  );
}
